/*
 * humo-header.js — Humo Commerce
 * Сжимает закреплённую шапку при прокрутке, чтобы она не съедала экран.
 */
(function () {
  'use strict';

  var THRESHOLD = 140;
  var header = document.querySelector('.js-site-header');
  if (!header) return;

  var ticking = false;
  var compact = false;

  function apply() {
    var shouldCompact = window.pageYOffset > THRESHOLD;
    if (shouldCompact !== compact) {
      compact = shouldCompact;
      header.classList.toggle('humo-header--compact', compact);
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(apply);
    }
  }, { passive: true });

  apply();
})();
